import React from "react";
import { Brain, TrendingUp, Compass, Handshake } from "lucide-react";
import { Card, CardHeader, CardTitle, CardContent, CardDescription } from "@/components/ui/card";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
const pathways = [{
  title: "Recovery Coaching",
  description: "Psychosocial support focused on resilience and personal agency. We implement structured goal tracking to ensure measurable progress in your recovery journey.",
  icon: Brain
}, {
  title: "Capacity Building",
  description: "Skill development designed to foster independence. Our documentation-driven approach captures functional improvements and tangible outcomes over time.",
  icon: TrendingUp
}, {
  title: "NDIS Counselling",
  description: "NDIS Counselling offers recovery-focused therapeutic support to assist participants in developing confidence, emotional resilience, and skills for meaningful community participation.",
  icon: Compass
}, {
  title: "NDIS Social Work",
  description: "NDIS Social Work supports people with disability to strengthen independence, improve wellbeing, and connect with community and services through personalised, goal-focused support.",
  icon: Handshake
}];
export default function StructuredSupportPathways() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="structured-support-pathways" ref={ref} className={`py-24 bg-background transition-opacity duration-700 ${isVisible ? "opacity-100" : "opacity-0"}`}>
      <div className="container mx-auto px-6">
        <div className="mb-16 text-center max-w-3xl mx-auto">
          <h2 className="text-3xl md:text-4xl font-semibold text-foreground mb-4 tracking-tight">
            Structured Support Pathways
          </h2>
          <p className="text-muted-foreground text-lg">
            We offer supportive, person-centred care that blends clinical expertise with compassion, helping you build confidence, reach your goals, and grow your independence.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6">
          {pathways.map((item, i) => <div key={i} data-index={i} className="h-full">
              <Card className="group h-full bg-white border border-border transition-all duration-300 hover:border-[var(--ring)] hover:shadow-md">
                <CardHeader className="pb-4">
                  <div className="mb-4 inline-flex items-center justify-center size-12 rounded-lg bg-secondary/10 text-secondary group-hover:text-[var(--ring)] group-hover:bg-[var(--ring)]/10 transition-colors duration-300">
                    <item.icon className="size-6 transition-transform duration-300 group-hover:scale-110 group-hover:rotate-3" strokeWidth={1.5} />
                  </div>
                  <CardTitle className="text-xl font-medium text-foreground group-hover:text-[var(--ring)] transition-colors duration-300">
                    {item.title}
                  </CardTitle>
                </CardHeader>
                <CardContent>
                  <CardDescription className="text-base leading-relaxed text-muted-foreground">
                    {item.description}
                  </CardDescription>
                </CardContent>
              </Card>
            </div>)}
        </div>
      </div>
    </section>;
}